import { render } from "./AuctionHouseCard.vue?vue&type=template&id=2e1a4d9e"
import script from "./AuctionHouseCard.vue?vue&type=script&lang=js"
export * from "./AuctionHouseCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__